export default __webpack_public_path__ + "static/media/RAMACHANDRA.c377fa1b.JPG";